import React, { useState , useEffect} from 'react';
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftAvatar from "components/SoftAvatar";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Settings from "examples/Icons/Settings";
import breakpoints from "assets/theme/base/breakpoints";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Footer from "examples/Footer";
import { fetchAuthSession  ,updateUserAttributes,signOut,getCurrentUser, updateMFAPreference, setUpTOTP  } from 'aws-amplify/auth';
import { useNavigate } from "react-router-dom"
import AWS from '../../aws-mock';
import Avatar from 'react-avatar-edit'
import {Buffer} from 'buffer';
import styled from "styled-components";
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormSelect,
  CRow,
  CCardImage,  
  CCardText,
  CCardTitle,  
  CAlert,
  CAlertHeading,
  CTable,
  CTableHead, 
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormInput,
  CFormCheck,
  CProgress,
  CProgressBar,
  CFormTextarea,
  CSpinner,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster
} from '@coreui/react'
import {
  Badge,
  Button,
  Form,
  Navbar,
  Nav,
  Container,
  Row,
  Col
} from "react-bootstrap";
import QRCode from 'react-qr-code';
import burceMars from "assets/images/bruce-mars.jpg";
import curved0 from "assets/images/curved-images/curved0.jpg";

function Overview() {
  const navigate = useNavigate();

  const [tabsOrientation, setTabsOrientation] = useState("horizontal");
  const [tabValue, setTabValue] = useState(0);
  useEffect(() => {
    function handleTabsOrientation() {
      return window.innerWidth < breakpoints.values.sm
        ? setTabsOrientation("vertical")
        : setTabsOrientation("horizontal");
    }
    window.addEventListener("resize", handleTabsOrientation);
    handleTabsOrientation();
    return () => window.removeEventListener("resize", handleTabsOrientation);
  }, [tabsOrientation]);
  const handleSetTabValue = (event, newValue) => setTabValue(newValue);


  const [name, setname] = useState()
  const [usernane, setusernane] = useState()
  const [email, setEmail] = useState()
  const [phone_number, setphone_number] = useState()
  const [profile, setprofile] = useState()
  const [codigo, setcodigo] = useState('+57');
  //const [codigo, setcodigo] = useState('');

  const [celular, setcelular] = useState();

  const [visible, setVisible] = useState(false)
  const [visible2, setVisible2] = useState(false)
  const [sec, setsec] = useState(10);
   

    //VOZ ERROR
    const cargarSonido2 = function () {
    const sonido2 = document.createElement("audio");
    sonido2.src = 'https://s3.amazonaws.com/perfil.primerosauxilios.online/voz/cambio+telefono.mp3';
    sonido2.setAttribute("preload", "auto");
    sonido2.setAttribute("controls", "none");
    sonido2.style.display = "none"; // <-- oculto
    document.body.appendChild(sonido2);
    return sonido2;
    };
    const sonido2 = cargarSonido2("sonido.flac");
    //FIN VOZ ERROR


    //VOZ CORRECTO
    const cargarSonido3 = function () {
    const sonido3 = document.createElement("audio");
    sonido3.src = 'https://s3.amazonaws.com/perfil.primerosauxilios.online/voz/cambio+telefono+correcto.mp3';
    sonido3.setAttribute("preload", "auto");
    sonido3.setAttribute("controls", "none");
    sonido3.style.display = "none"; // <-- oculto
    document.body.appendChild(sonido3);
    return sonido3;
    };
    const sonido3 = cargarSonido3("sonido.flac");
    //FIN VOZ CORRECTO


    async function ActualizarCelular(){
    const numero = document.getElementById("celular").value;

    if( numero.length==0 ){
      setVisible(true);
      sonido2.play();
    }else{

      try {
        await updateUserAttributes({
          userAttributes: {
            phone_number: codigo+celular
          },
        }).then(data => 
        {

          document.getElementById("celular").value = "";
          sonido3.play();
          setVisible2(true);
           setTimeout(function(){
            setsec(9);
            },1000)
            setTimeout(function(){
            setsec(8);
            },2000)
            setTimeout(function(){
             setsec(7);
            },3000)
            setTimeout(function(){
             setsec(6);
            },4000)
            setTimeout(function(){
             setsec(5);
            },5000)
            setTimeout(function(){
              signOut();
              window.location.reload();
            },6000)

        });
      } catch (err) {
        console.log(err);
      }

    }
   } 

   const [origen, setOrigen] = useState('');

   useEffect(() => {
    (async () => {
      try {
        await fetchAuthSession().then(data => 
        {
          setUser(data.tokens.accessToken.payload.sub)
          setEmail(data.tokens.idToken.payload.email)
          setname(data.tokens.idToken.payload.name)
          setphone_number(data.tokens.idToken.payload.phone_number)
          setprofile(data.tokens.idToken.payload.profile)
          setMFA(data.tokens.idToken.payload.preferred_username)
          setusernane(data.tokens.accessToken.payload.username)

          const url = `https://sjdwqogwxkm2cdrbjwkxweuxuy0pzacn.lambda-url.us-east-1.on.aws/?correo=${data.tokens.idToken.payload.email}`;

          fetch(url)
          .then(response => {
            // Verifica que la respuesta esté ok
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json(); // Convierte la respuesta en JSON
          })
          .then(data => {
            setOrigen(data.titulo)
          })
          .catch(error => {
            console.error('Error al hacer la petición:', error);
          });


        });
  
      } catch (err) {
        console.log(err);
      }
  
    })();	
  },[]);



 //AGREGAR A S3
 const S3_BUCKET ='perfil.primerosauxilios.online';
 const REGION ='us-east-1';
 AWS.config.update({
     accessKeyId: process.env.REACT_APP_ACCESSKEYID,
     secretAccessKey: process.env.REACT_APP_SECRETACCESSKEY
 })
 const myBucket = new AWS.S3({
     params: { Bucket: S3_BUCKET},
     region: REGION,
 })

 //datos cognito
 const [sub, setUser] = useState()

 const [fot, setFot] = useState();
 const [mfa, setMFA] = useState('');

useEffect(() => {
  (async () => {
    try {
      await fetchAuthSession().then(data => 
      {

        let img = data.tokens.idToken.payload.picture;
        if (data.tokens.idToken.payload.picture !== undefined && data.tokens.idToken.payload.picture !== null) {
          console.log("aqui")
          setFot(img + "?t=" + new Date().getTime())
        }else{
          console.log("aca")
          setFot("https://s3.amazonaws.com/www.codeflex.lat/documentos/1b4eec84-2a0d-4cdb-8eb1-404f5204fdcd/Ftoo/icegif-1038.gif")
        }
      });
    } catch (err) {
      console.log(err);
    }

  })();	
},[]);


 //IMAGEN FILE
 const [src, setSrc] = useState(null)
 const [preview, setPreview] = useState('')

 const onClose =()=>{
   setPreview('');
 }

 const onCrop = view =>{
   setPreview(view);
 }

 const onBeforeFileLoad=(elem)=>{
   setselectedFile(elem.target.files[0]); 
   console.log(elem.target.files[0]);
   //const objectUrl = URL.createObjectURL(elem.target.files[0])
   
 }

 function reset(){
  navigate('/');
  window.location.reload()
 }
 

 //TIPO FILE
 const [selectedFile, setselectedFile] = useState(null)
 const [visible3, setVisible3] = useState(false)
 const [visible4, setVisible4] = useState(false)

 //VOZ ERROR
 const cargarSonido = function () {
 const sonido = document.createElement("audio");
 sonido.src = 'https://s3.amazonaws.com/perfil.primerosauxilios.online/voz/foto+perfil.mp3';
 sonido.setAttribute("preload", "auto");
 sonido.setAttribute("controls", "none");
 sonido.style.display = "none"; // <-- oculto
 document.body.appendChild(sonido);
 return sonido;
 };
 const sonido = cargarSonido("sonido.flac");
 //FIN VOZ ERROR


//VOZ CORRECTO
 const cargarSonido4 = function () {
 const sonido4 = document.createElement("audio");
 sonido4.src = 'https://s3.amazonaws.com/perfil.primerosauxilios.online/voz/foto+perfil+correcto.mp3';
 sonido4.setAttribute("preload", "auto");
 sonido4.setAttribute("controls", "none");
 sonido4.style.display = "none"; // <-- oculto
 document.body.appendChild(sonido4);
 return sonido4;
 };
 const sonido4 = cargarSonido4("sonido.flac");
 //FIN VOZ CORRECTO


 //BOTON ACTUALIZAR FOTO
 function ActualizarFoto(){
   console.log(preview.length)
   if(preview.length==0 ){
     sonido.play();
     setVisible3(true);
   }else{
     var buf = Buffer.from(preview.replace(/^data:image\/\w+;base64,/, ""),'base64');
     const params = {
       ACL: 'public-read',
       Body: buf,
       ContentEncoding: 'base64',
       Bucket: S3_BUCKET,
       ContentType: 'image/jpeg',
       Key: "foto-perfil/" + sub + ".png"
     };
     myBucket.putObject(params).send((err) => {
       if (err) { console.log(err) } else {

          fottto();

         } 
       });
       setPreview('');
   }
 }


 async function fottto(){
  const elem = document.getElementById("b2");
  const elem2 = document.getElementById("b1");
  try {
    await updateUserAttributes({
      userAttributes: {
        picture: "https://s3.amazonaws.com/perfil.primerosauxilios.online/foto-perfil/" + sub + ".png"
      },
    }).then(data => 
    {
      console.log("Success");
      sonido4.play();
      setVisible4(true);
      elem2.style.display = 'none';
      elem.style.display = 'flex';

        setTimeout(function(){
        setsec(9);
        },1000)
        setTimeout(function(){
        setsec(8);
        },2000)
        setTimeout(function(){
          setsec(7);
        },3000)
        setTimeout(function(){
          setsec(6);
        },4000)
        setTimeout(function(){
          setsec(5);
        },5000)
        setTimeout(function(){
          navigate('/');
          window.location.reload()
        },6000)

    });
  } catch (err) {
    console.log(err);
  }
} 

async function Actuali() {
  try {
    await updateUserAttributes({
      userAttributes: {
        preferred_username: "true"
      },
    }).then(data => 
    {
      console.log("actualizado")
      alert('MFA habilitado con éxito mediante SMS.')
      signOut();
      window.location.reload();
    });
  } catch (err) {
    console.log(err);
  }
}

async function Actuali2() {
  try {
    await updateUserAttributes({
      userAttributes: {
        preferred_username: ""
      },
    }).then(data => 
    {
      console.log("actualizado")
      alert('MFA deshabilitado')
      signOut();
      window.location.reload();
    });
  } catch (err) {
    console.log(err);
  }
}

const cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider({region: 'us-east-1'});
const enableMFA = async () => {
  const userPoolId = 'us-east-1_iP2TUEJmw';
  const params = {
    UserPoolId: userPoolId,
    Username: usernane,
    SMSMfaSettings: {
      Enabled: true,
      PreferredMfa: true
    }
  };
  try {
    await cognitoIdentityServiceProvider.adminSetUserMFAPreference(params).promise();
    console.log("correcto")
    Actuali()
  } catch (error) {
    console.error('Error configurando MFA:', error);
    alert('Ocurrió un error al configurar MFA. Por favor, intenta de nuevo.');
  }
};

const desableMFA = async () => {
  const userPoolId = 'us-east-1_iP2TUEJmw';
  const params = {
    UserPoolId: userPoolId,
    Username: usernane,
    SMSMfaSettings: {
      Enabled: false,
      PreferredMfa: false
    }
  };
  try {
    await cognitoIdentityServiceProvider.adminSetUserMFAPreference(params).promise();
    console.log("correcto")
    Actuali2()
  } catch (error) {
    console.error('Error configurando MFA:', error);
    alert('Ocurrió un error al configurar MFA. Por favor, intenta de nuevo.');
  }
};

  return (
    <DashboardLayout>
      <SoftBox position="relative">
        <DashboardNavbar absolute light />
        <SoftBox
          display="flex"
          alignItems="center"
          position="relative"
          minHeight="18.75rem"
          borderRadius="xl"
          sx={{
            backgroundImage: ({ functions: { rgba, linearGradient }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.info.main, 0.6),
                rgba(gradients.info.state, 0.6)
              )}, url(${curved0})`,
            backgroundSize: "cover",
            backgroundPosition: "50%",
            overflow: "hidden",
          }}
        />
        <Card
          sx={{
            backdropFilter: `saturate(200%) blur(30px)`,
            backgroundColor: ({ functions: { rgba }, palette: { white } }) => rgba(white.main, 0.8),
            boxShadow: ({ boxShadows: { navbarBoxShadow } }) => navbarBoxShadow,
            position: "relative",
            mt: -8,
            mx: 3,
            py: 2,
            px: 2,
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid item>
              <SoftAvatar
                src={fot}
                alt="profile-image"
                size="xl"
                shadow="sm"
              />
            </Grid>
            <Grid item>
              <SoftBox height="100%" mt={0.5} lineHeight={1}>
                <SoftTypography variant="h5" fontWeight="medium">
                  {name}
                </SoftTypography>
                <SoftTypography variant="button" color="text" fontWeight="medium">
                  {email}
                </SoftTypography>
              </SoftBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4} sx={{ ml: "auto" }}>
              <AppBar position="static">
                {mfa ?
                <Tabs
                  orientation={tabsOrientation}
                  value={tabValue}
                  onClick={desableMFA}
                  sx={{ background: "transparent" }}
                >
                  <Tab label="Desactivar (MFA | SMS)" icon={<Settings />} />
                </Tabs>
                :
                <Tabs
                  orientation={tabsOrientation}
                  value={tabValue}
                  onClick={enableMFA}
                  sx={{ background: "transparent" }}
                >
                  <Tab label="Activar (MFA | SMS)" icon={<Settings />} />
                </Tabs>
                }
              </AppBar>
            </Grid>
          </Grid>
        </Card>
      </SoftBox>
      
      <SoftBox mt={4}>
      <CCard className="mb-4 ccard-custom-style">
        <CCardHeader>
          <CCardTitle as="h4">Edit Profile</CCardTitle>
        </CCardHeader>
              <CCardBody>
                <Form>
                  <CRow>
                    <CCol className="px-1" md="6">
                      <Form.Group>
                        <label>Username</label>
                        <Form.Control
                          defaultValue={usernane}
                          disabled
                          placeholder="Username"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </CCol>
                    <CCol className="pl-1" md="6">
                      <Form.Group>
                        <label htmlFor="exampleInputEmail1">
                          Email
                        </label>
                        <Form.Control
                          placeholder="email"
                          defaultValue={email}
                          disabled
                          type="email"
                        ></Form.Control>
                      </Form.Group>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol md="6">
                      <Form.Group>
                        <label>Nombre</label>
                        <Form.Control
                          defaultValue={name}
                          disabled
                          placeholder="Company"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </CCol>
                    <CCol md="6">
                      <Form.Group>
                        <label>Origen del correo</label>
                        <Form.Control
                          defaultValue={origen}
                          disabled
                          placeholder="Buscando compañía..."
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol className="px-1" md="5">
                      <Form.Group>
                        <label>Telefono</label>
                        <Form.Control
                          defaultValue={phone_number}
                          disabled
                          placeholder="Country"
                          type="text"
                        ></Form.Control>
                      </Form.Group>
                    </CCol>
                    <CCol className="pl-1" md="2">
                      <Form.Group>
                        <CFormSelect size="sm" className='codigo' id="inputState" label="Indicativo" value={codigo}  onChange={c => setcodigo(c.target.value)}>
                        <option value="+1">+1</option>
                      <option value="+7">+7</option>
                      <option value="+20">+20</option>
                      <option value="+27">+27</option>
                      <option value="+30">+30</option>
                      <option value="+31">+31</option>
                      <option value="+32">+32</option>
                      <option value="+33">+33</option>
                      <option value="+34">+34</option>
                      <option value="+36">+36</option>
                      <option value="+39">+39</option>
                      <option value="+40">+40</option>
                      <option value="+41">+41</option>
                      <option value="+41">+43</option>
                      <option value="+44">+44</option>
                      <option value="+45">+45</option>
                      <option value="+46">+46</option>
                      <option value="+47">+47</option>
                      <option value="+48">+48</option>
                      <option value="+49">+49</option>
                      <option value="+51">+51</option>
                      <option value="+52">+52</option>
                      <option value="+53">+53</option>
                      <option value="+54">+54</option>
                      <option value="+55">+55</option>
                      <option value="+56">+56</option>
                      <option value="+57">+57</option>
                      <option value="+58">+58</option>
                      <option value="+60">+60</option>
                      <option value="+61">+61</option>
                      <option value="+62">+62</option>
                      <option value="+63">+63</option>
                      <option value="+64">+64</option>
                      <option value="+65">+65</option>
                      <option value="+66">+66</option>
                      <option value="+81">+81</option>
                      <option value="+82">+82</option>
                      <option value="+84">+84</option>
                      <option value="+86">+86</option>
                      <option value="+90">+90</option>
                      <option value="+91">+91</option>
                      <option value="+92">+92</option>
                      <option value="+93">+93</option>
                      <option value="+94">+94</option>
                      <option value="+95">+95</option>
                      <option value="+98">+98</option>
                      <option value="+212">+212</option>
                      <option value="+213">+213</option>
                      <option value="+216">+216</option>
                      <option value="+218">+218</option>
                      <option value="+220">+220</option>
                      <option value="+221">+221</option>
                      <option value="+222">+222</option>
                      <option value="+223">+223</option>
                      <option value="+224">+224</option>
                      <option value="+225">+225</option>
                      <option value="+226">+226</option>
                      <option value="+227">+227</option>
                      <option value="+228">+228</option>
                      <option value="+229">+229</option>
                      <option value="+230">+230</option>
                      <option value="+231">+231</option>
                      <option value="+232">+232</option>
                      <option value="+233">+233</option>
                      <option value="+234">+234</option>
                      <option value="+235">+235</option>
                      <option value="+236">+236</option>
                      <option value="+237">+237</option>
                      <option value="+238">+238</option>
                      <option value="+239">+239</option>
                      <option value="+240">+240</option>
                      <option value="+241">+241</option>
                      <option value="+242">+242</option>
                      <option value="+243">+243</option>
                      <option value="+244">+244</option>
                      <option value="+245">+245</option>
                      <option value="+246">+246</option>
                      <option value="+248">+248</option>
                      <option value="+249">+249</option>
                      <option value="+250">+250</option>
                      <option value="+251">+251</option>
                      <option value="+252">+252</option>
                      <option value="+253">+253</option>
                      <option value="+254">+254</option>
                      <option value="+255">+255</option>
                      <option value="+256">+256</option>
                      <option value="+257">+257</option>
                      <option value="+258">+258</option>
                      <option value="+260">+260</option>
                      <option value="+261">+261</option>
                      <option value="+262">+262</option>
                      <option value="+263">+263</option>
                      <option value="+264">+264</option>
                      <option value="+265">+265</option>
                      <option value="+266">+266</option>
                      <option value="+267">+267</option>
                      <option value="+268">+268</option>
                      <option value="+269">+269</option>
                      <option value="+290">+290</option>
                      <option value="+291">+291</option>
                      <option value="+297">+297</option>
                      <option value="+298">+298</option>
                      <option value="+299">+299</option>
                      <option value="+380">+380</option>
                      <option value="+502">+502</option>
                      <option value="+505">+505</option>
                      <option value="+506">+506</option>
                      <option value="+507">+507</option>
                      <option value="+591">+591</option>
                      <option value="+593">+593</option>
                      <option value="+595">+595</option>
                      <option value="+598">+598</option> 
                      </CFormSelect>
                      </Form.Group>
                    </CCol>
                    <CCol className="pl-1" md="5">
                      <Form.Group>
                        <label>Nuevo Telefono</label>
                        <Form.Control
                          placeholder="Phone Number"
                          required=""  
                          id="celular"
                          pattern="[0-9]+"
                          value={celular}  
                          onChange={e => setcelular(e.target.value)}
                          type="number"
                        ></Form.Control>
                      </Form.Group>
                    </CCol>
                  </CRow><br/>
                  <hr/><br/>
                  <center>
                     <CButton  class="btn btn-success rounded-pill" id='bttn' onClick={ActualizarCelular} >Actualizar Teléfono</CButton>
                  </center>
                  <br/>
                  <CAlert color="danger" dismissible visible={visible} onClose={() => setVisible(false)}>
                  <CAlertHeading component="h4">ERROR!</CAlertHeading>
                  <p>Por favor llene el campo del numero telefonico, junto al codigo del pais para poder continuar.</p>
                  <hr />
                  <p className="mb-0">Drive© 2023.</p>
                  </CAlert>

                  <CAlert color="success" dismissible visible={visible2}>
                        <CAlertHeading component="h4">CORRECTO!</CAlertHeading>
                        <p>Numero telefonico actualizado, por favor volver a iniciar sesion o espere <span>
                        <input id="se"  value={sec} onChange={e => setsec(e.target.value)} type="number" disabled />
                        </span> segundos para ver los cambios.</p>
                        <hr />
                        <p className="mb-0">Drive© 2023.</p>
                  </CAlert>

                  <div className="clearfix"></div>
                </Form>
              </CCardBody>
            </CCard><br/>


            <CCard className="mb-4 ccard-custom-style">
              <CAlert color="danger" dismissible visible={visible3} onClose={() => setVisible3(false)}>
                <CAlertHeading component="h4">ERROR!</CAlertHeading>
                <p>Por favor seleccione un archivo del escritorio o la camara del dispositivo, se permite cualquier formato de imagen.</p>
                <hr />
                <p className="mb-0">Cloud Storage Service© 2023.</p>
              </CAlert>

              <CAlert color="success" dismissible visible={visible4} >
                <CAlertHeading component="h4">CORRECTO!</CAlertHeading>
                <p>Foto de perfil actualizada, por favor refrescar la pagina en el boton amarillo o espere <span>
                <input id="se"  value={sec} onChange={e => setsec(e.target.value)} type="number" disabled />
                </span> segundos para ver los cambios.</p>
                <hr /> 
                <p className="mb-0">Cloud Storage Service© 2023.</p>
              </CAlert>

              <CCardHeader >
                <strong >Cloud Storage Service</strong> <small>/Foto de perfil</small>
              </CCardHeader>

              <CCardBody>
                <CRow>
                  <CCol lg={6}>
                    <CCard className="mb-3">
                      <CCardBody>
                        <CCardTitle className='tit' >Seleccione Imagen<br/></CCardTitle><br/>
                        <CCardText >
                          <center>
                          <div id='imaa'>
                          <Avatar
                            width={204}
                            height={204}
                            onCrop={onCrop}
                            onClose={onClose}
                            src={src}
                            onBeforeFileLoad={onBeforeFileLoad}
                            />
                          </div>
                          </center>
                        </CCardText>
                      </CCardBody>
                    </CCard>
                  </CCol>

                  <CCol lg={6}>
                    <CCard className="mb-3">
                      <CCardBody >
                        <CCardTitle className='tit'>Vista Previa<br/></CCardTitle><br/>
                          <CCardText >
                            <br/>
                            <center>
                            <CCardImage  orientation="top" src={preview}  style={{ width: '40%' }}/>
                            </center>
                            <br/>
                          </CCardText>   
                          <div id='boto'>
                            <center> 
                            <CButton  class="btn btn-info rounded-pill" id='b1'  onClick={ActualizarFoto} >Cambiar Foto</CButton>
                            <CButton  class="btn btn-warning rounded-pill" id='b2'  onClick={reset} >Refrescar Pagina</CButton>
                            </center>
                          </div><br/>
                      </CCardBody>
                    </CCard>
                  </CCol>
                </CRow>
              </CCardBody>
            </CCard>

      </SoftBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Overview;


const StyleDragArea = styled.div`
  .center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .file-upload-content {
    display: none;
    text-align: center;
  }

  .file-upload-input {
    position: absolute;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    outline: none;
    opacity: 0;
    cursor: pointer;
  }

  .image-upload-wrap {
    position: relative;
    height: 100px;
    border: 2px dashed #d0d7de;
    margin-left: 10px;
    margin-right: 10px;
  }

  .image-upload-wrap:hover {
    background-color: transparent;
    border: 4px dashed #d0d7de;
  }
  .text-information {
    margin-top: 30px;
    text-align: center;
  }
`;